<ng-container
  *ngIf="
    currentPath?.startsWith('/employee') ||
      currentPath?.startsWith('/sign-in') ||
      currentPath?.startsWith('/sign-up') ||
      currentPath?.startsWith('/forgot-password');
    else websiteTemplate
  "
>
  <router-outlet></router-outlet>
</ng-container>
<ng-template #websiteTemplate>
  <tvt-logistics-india-preloader></tvt-logistics-india-preloader>
  <tvt-logistics-india-navbar
    *ngIf="!(location == '/coming-soon')"
  ></tvt-logistics-india-navbar>
  <router-outlet></router-outlet>
  <tvt-logistics-india-footer
    *ngIf="!(location == '/coming-soon')"
  ></tvt-logistics-india-footer>
</ng-template>
